import { ArrowDownward, ArrowForward, ArrowUpward } from '@mui/icons-material'
import { Chip, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { KpiBadge } from '../benchmark/kpiCardLogic'
import { KpiBadgeKind } from '../benchmark/kpiCardLogic'
import { POSITIVE_COLOR } from './profileColors'

const POSITIVE_BADGE = {
  bgcolor: 'success.light',
  icon: <ArrowUpward aria-hidden sx={{ fontSize: 16, color: POSITIVE_COLOR }} />,
}

const BADGE_STYLE: Record<KpiBadgeKind, { bgcolor: string; icon: React.ReactElement }> = {
  [KpiBadgeKind.BelowAverage]: {
    bgcolor: 'error.light',
    icon: <ArrowDownward aria-hidden sx={{ fontSize: 16, color: 'semantic.error' }} />,
  },
  [KpiBadgeKind.Average]: {
    bgcolor: 'warning.light',
    icon: <ArrowForward aria-hidden sx={{ fontSize: 16, color: 'warning.dark' }} />,
  },
  [KpiBadgeKind.AboveAverage]: POSITIVE_BADGE,
  [KpiBadgeKind.Top]: POSITIVE_BADGE,
}

const KpiBadgeChip: React.FC<{ badge: KpiBadge }> = ({ badge }) => {
  const { formatMessage } = useIntl()
  const { bgcolor, icon } = BADGE_STYLE[badge.kind]

  return (
    <Chip
      size="small"
      icon={icon}
      label={
        <Typography variant="caption" color="text.primary">
          {formatMessage({ id: `sustainabilityProfile.kpi.badge.${badge.kind}` }, { percent: badge.topPercent })}
        </Typography>
      }
      sx={{ bgcolor }}
    />
  )
}

export default KpiBadgeChip
